'use strict';

const React = require('react');

const heading = (status) => {
	if(status < 500) {
		return 'Sidan finns... inte. Konstigt.';
	} else {
		return 'AJ, Något gick fel...';
	}
};

const StatusMessage = ({status}) => {
	return (
		<section className="svtse_404">
			<article className="svtse_404__article">
				<h1 className="svtse_404__heading">
					{heading(status)}
				</h1>

				<p className="svtse_404__text">
					Det kan vara så att du har gått till fel adress eller att en länk är gammal och trasig. Så kan
					det vara på Internet. Vi ber om ursäkt om det skulle vara vårt fel.
				</p>
			</article>
		</section>
	);
};

module.exports = StatusMessage;



/** WEBPACK FOOTER **
 ** ./app/components/StatusMessage/index.js
 **/